import { format } from 'date-fns';

export const DEFAULT_HISTORY_RANGE = 'year';

const multipleFormatter = new Intl.NumberFormat('es-ES', {
  maximumFractionDigits: 1,
});

const percentFormatter = new Intl.NumberFormat('es-ES', {
  style: 'percent',
  maximumFractionDigits: 2,
});

const plainPriceFormatter = new Intl.NumberFormat('es-ES', {
  maximumFractionDigits: 2,
});

/**
 * The API sends metrics as strings, and null means "no data that day", never
 * zero. Anything that is not a finite number becomes null so the chart leaves
 * a gap instead of dropping the line to 0.
 */
export const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

/**
 * Averages from GET /companies are null when there is no data.
 */
export const toAverageOrNull = (value) => {
  const number = toNumberOrNull(value);
  return number === 0 ? null : number;
};

export const formatMultiple = (value) =>
  value === null || value === undefined
    ? ''
    : `${multipleFormatter.format(value)}x`;

export const formatPercent = (value) =>
  value === null || value === undefined ? '' : percentFormatter.format(value);

export const formatPrice = (value, currency) => {
  if (value === null || value === undefined) {
    return '';
  }
  if (!currency) {
    return plainPriceFormatter.format(value);
  }
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency,
  }).format(value);
};

export const METRICS = [
  { key: 'price', title: 'Price', format: formatPrice },
  {
    key: 'forwardPE',
    title: 'Forward PE',
    unit: 'x',
    format: formatMultiple,
    averageKey: 'avgForwardPE',
  },
  {
    key: 'enterpriseToRevenue',
    title: 'EV/Revenue',
    unit: 'x',
    format: formatMultiple,
    averageKey: 'avgEnterpriseToRevenue',
  },
  {
    key: 'enterpriseToEbitda',
    title: 'EV/EBITDA',
    unit: 'x',
    format: formatMultiple,
    averageKey: 'avgEnterpriseToEbitda',
  },
  {
    key: 'profitMargins',
    title: 'Profit margin',
    unit: '%',
    format: formatPercent,
    averageKey: 'avgProfitMargins',
  },
  {
    key: 'shortPercentOfFloat',
    title: 'Short interest',
    unit: '% of float',
    format: formatPercent,
  },
];

export const toChartPoints = (points = []) =>
  points.map((point) => ({
    ts: new Date(point.timestamp).getTime(),
    ...Object.fromEntries(
      METRICS.map(({ key }) => [key, toNumberOrNull(point[key])]),
    ),
  }));

export const hasValues = (chartPoints, key) =>
  chartPoints.some((point) => point[key] !== null);

export const formatTimestamp = (ts, range) =>
  format(new Date(ts), range === 'week' ? 'dd/MM HH:mm' : 'dd/MM/yy');
